module.exports = __webpack_public_path__ + "static/media/image_add.3ed23dc6.svg";